import User from 'user';
import Submission from '../modules/quality-mentoring-form/models/submission/Submission';
import SubmissionCollection from '../modules/quality-mentoring-form/models/submission/SubmissionCollection';

import Info from './Info';
import QualityMentoringForm from "../modules/quality-mentoring-form/models/QualityMentoringForm";

export default class Manager {
  private static instance: Manager;

  public app: any;

  public i18n: any;

  public langCodes = ['en', 'fr'];

  public routes: any[] = [];

  public readonly user: User;

  public readonly submissions: SubmissionCollection;

  public submission: Submission;

  public serverInfo: Info = new Info();

  public isOnboarded: boolean = false;

  constructor() {
    this.user = new User();
    this.submissions = new SubmissionCollection();
  }

  public async load() {
    await this.user.init();
    await this.serverInfo.load();
    if (!this.user.getUid()) {
      return;
    }

    await QualityMentoringForm.getSchema();
    await this.submissions.load();
    this.submission = new Submission();
    if (this.submissions.list.length) {
      const id = this.getSubmissionId() || this.submissions.list[0].id;
      await this.submission.load(id);
      this.isOnboarded = true;
    }
  }

  public static getInstance(): Manager {
    if (!Manager.instance) {
      Manager.instance = new Manager();
    }
    return Manager.instance;
  }

  public addRoutes(routes: any) {
    this.routes = this.routes.concat(routes);
  }

  private getSubmissionId() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    return urlParams.get('id');
  }
}
